/**
 * ai-index-redirect.tsx — `/ai`: không còn là trang riêng.
 *  - Link cũ `/ai?tab=…` → trang mới tương ứng (bots / config / usage / logs / eval / knowledge).
 *  - Còn lại: có nhân viên AI đang trả lời → `/ai/nhan-vien`; chưa → `/ai/bat-dau` (Bắt đầu).
 * Các tham số khác (vd `from=onboarding&step=3`) được giữ nguyên.
 */
import { Navigate, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Loading } from '@/components/shared/feedback'
import { useAiBots } from '@/hooks/use-ai'
import { AI_PATHS, aiIndexTarget, legacyAiTabTarget } from '@/lib/ai-khung'

export function AiIndexRedirect() {
  const { t } = useTranslation('aiWizard')
  const { search } = useLocation()
  const legacy = legacyAiTabTarget(search)
  const { data, isLoading, isError } = useAiBots()
  if (legacy) return <Navigate to={legacy} replace />
  if (isLoading) return <Loading label={t('redirect.opening')} />
  if (isError || !data) return <Navigate to={`${AI_PATHS.bots}${search}`} replace />
  return <Navigate to={aiIndexTarget(search, data.bots)} replace />
}
